import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AngularMaterialModule } from 'src/app/angular-material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { DialogSaveCloseModule } from 'src/app/shared/components/dialog-save-close/dialog-save-close.module';
import { DialogContainerModule } from 'src/app/shared/dialog-container/dialog-container.module';
import { NotificationDialogComponent } from './notification-dialog/notification-dialog.component';
import { NotificationSettingsComponent } from './notification-settings/notification-settings.component';
import { NotificationComponent } from './notification.component';
import { FormsModule } from '@angular/forms';
import { ReminderNotificationModalComponent } from '../../components/modals/reminder-notification-modal/reminder-notification-modal.component';

@NgModule({
  declarations: [
    NotificationComponent,
    ReminderNotificationModalComponent,
    NotificationDialogComponent,
    NotificationSettingsComponent
  ],
  imports: [
    FormsModule,
    CommonModule,
    AngularMaterialModule,
    FlexLayoutModule,
    DialogSaveCloseModule,
    DialogContainerModule
  ],
  exports: [
    NotificationComponent,
    NotificationDialogComponent,
    NotificationSettingsComponent,
    ReminderNotificationModalComponent
  ]
})
export class NotificationModule { }
